import { useState } from "react";
import {
  IndexFaqComponentFaqItem,
  IndexFaqComponentMainDiv,
} from "../../styles/indexcomponentsstyles/indexfaqcomponentstyles";
import ButtonComponentVariant from "../reusable/header/assetes/buttoncomponents/buttoncomponentvarint";
import HeaderSpan from "../reusable/header/assetes/buttoncomponents/headerspan";

const IndexFaqComponent = () => {
  const [open, setIsOpen] = useState<number>(1);
  return (
    <IndexFaqComponentMainDiv>
      <div>
        <div className="faq-container">
          <div className="faq-left">
            <div>
              <div className="faq-header">
                <div>
                  <div>
                    <HeaderSpan text="FAQ" />
                  </div>
                </div>
                <div>
                  <div className="faq-text-container">
                    <h2>Frequently asked questions</h2>
                  </div>
                </div>
              </div>
            </div>
            <div className="faq-description-wrapper">
              <div>
                <div>
                  <div className="faq-text-container ">
                    <h4>Got any Questions?</h4>
                  </div>
                </div>
                <div>
                  <div className="faq-text-container ">
                    <p>
                      Let us know! Reach out and our team will get right back to
                      you.
                    </p>
                  </div>
                </div>
              </div>
              <div>
                <div className="faq-button-wrapper ">
                  <ButtonComponentVariant title="Contact us " link="/contact" />
                </div>
              </div>
            </div>
          </div>
          <div className="faq-questions-container ">
            {data.map((item, index) => (
              <IndexFaqComponentFaqItem
                isOpened={open === index}
                onClick={() => {
                  setIsOpen(index);
                }}
              >
                <div>
                  <div>
                    <div className="faq-item-header">
                      <div>
                        <div className=" faq-text-wrapper ">
                          <h3> {item.question} </h3>
                        </div>
                      </div>
                      <div>
                        {" "}
                        <div className="faq-cross-icon-contaner">
                          <div />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className=" faq-text-boottom-text-contaner">
                    <div className="faq-text-wrapper ">
                      <p>
                       {
                        item.answer
                       }
                      </p>
                    </div>{" "}
                  </div>
                </div>
              </IndexFaqComponentFaqItem>
            ))}
          </div>
        </div>
      </div>
    </IndexFaqComponentMainDiv>
  );
};

const data = [
  {
    "question": "What is Bugzi AI?",
    "answer": "Bugzi AI is an extension that lets you interact with leading AI models like Claude, Gemini, and GPT directly inside your favorite IDE."
  },
  {
    "question": "How do I get started with Bugzi AI?",
    "answer": "Simply download the extension, select your preferred AI model, and start running tasks or generating content right away."
  },
  {
    "question": "Which AI models does Bugzi AI support?",
    "answer": "Bugzi AI supports multiple models including Claude, Gemini, GPT, and more, giving you flexibility to choose the best fit for your needs."
  },
  {
    "question": "Do I need any special setup to use Bugzi AI?",
    "answer": "No extra setup is required. Once installed, Bugzi AI integrates seamlessly with your IDE for instant use."
  },
  {
    "question": "Can Bugzi AI help with coding tasks?",
    "answer": "Yes, Bugzi AI can assist with coding, debugging, and generating content, making your development process faster and easier."
  },
  {
    "question": "Is Bugzi AI easy to use?",
    "answer": "Absolutely. Bugzi AI is designed to be intuitive and customer‑friendly, so you can focus on your work while it handles the heavy lifting."
  }
]

export default IndexFaqComponent;
